import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = { class: "forgot-password-box" }
const _hoisted_4 = { class: "auth-links" }
const _hoisted_5 = { class: "admin-message" }
const _hoisted_6 = { class: "back-link" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ForgotPasswordView',
  setup(__props) {

// No additional logic needed

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("auth.forgotPassword.title")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("auth.forgotPassword.message")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("auth.forgotPassword.backToLogin")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "copyright" }, " © PEIMAR INDUSTRIES S.r.l. Via Cavezzo 26, 25045 Castegnato – BS Italy.P.IVA IT03943830988 – REA: BS-575881 – Capitale Sociale Euro 500.000,00 ", -1))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "right-side" }, null, -1))
  ]))
}
}

})